import { CuratedProductListParametersType } from "@sellar-io/api-v2/types";

import { useSpotlightPage } from "../../hooks/api/v2/spotlight-page/useSpotlightPage";

import { SpotlightPageGetResponseType } from "@sellar-io/api-v2/types";

export type SpotlightPagesType = {
  title: string;
  description?: string;
  logoUrl?: string;
  bannerSmallUrl?: string;
  bannerMediumUrl?: string;
  bannerLargeUrl?: string;
  spotlightBannerUrl?: string;
  query?: CuratedProductListParametersType["query"];
  search?: string;
  hiddenFilters?: ("abv" | "price")[];
};

export const fallbackSpotlightPages: {
  [key: string]: SpotlightPagesType;
} = {
  "manchester-craft-beer-festival-2025": {
    title: "Manchester Craft Beer Festival",
    description:
      "Manchester's finest, all in one place. Discover the freshest drops pouring at the MCBF trade day - only on Sellar Market.",
    logoUrl: "https://sellar.imgix.net/mcbf-2025/mcbf-text.png",
    bannerSmallUrl: "https://sellar.imgix.net/mcbf-2025/mcbf-slim.png",
    bannerMediumUrl: "https://sellar.imgix.net/mcbf-2025/mcbf-medium.png",
    bannerLargeUrl: "https://sellar.imgix.net/mcbf-2025/mcbf-large.png",
  },
  "uk-lager-2025": {
    title: "UK Lager",
    description:
      "We're shining a spotlight on Lagers lovingly brewed right here in the UK — crisp, refreshing, and perfect for the warmer months ahead. From small-batch brews to cult classics, this is your cue to stock up on crispy bois and keep your taps and fridges summer-ready.",
    logoUrl:
      "https://sellar.imgix.net/sellar-image-assets/uk-lager-2025/text-logo.png",
    bannerSmallUrl:
      "https://sellar.imgix.net/sellar-image-assets/uk-lager-2025/slim-2.png",
    bannerMediumUrl:
      "https://sellar.imgix.net/sellar-image-assets/uk-lager-2025/medium.png",
    bannerLargeUrl:
      "https://sellar.imgix.net/sellar-image-assets/uk-lager-2025/large.png",
    spotlightBannerUrl:
      "https://sellar.imgix.net/sellar-image-assets/uk-lager-2025/new-aspect.png",
  },
  "low-and-no": {
    title: "Low & No",
    description:
      "Stock your venue from the largest collection of low and no alcohol craft drinks in the UK. Offer your customers the freshest, most exciting drinks for their moderation exploration.",
    logoUrl:
      "https://sellar.imgix.net/sellar-image-assets/lowandno/low-and-no-logo.png",
    bannerSmallUrl:
      "https://sellar.imgix.net/sellar-image-assets/lowandno/low-and-no-banner-small.png",
    bannerMediumUrl:
      "https://sellar.imgix.net/sellar-image-assets/lowandno/low-and-no-banner-medium.png",
    bannerLargeUrl:
      "https://sellar.imgix.net/sellar-image-assets/lowandno/low-and-no-banner-large.png",
    query: [
      {
        type: "abv",
        modifier: "BETWEEN",
        value: { low: 0, high: 0.5 },
      },
      { type: "abv", modifier: "LESS_THAN", value: 2 },
      { type: "abv", modifier: "BETWEEN", value: { low: 2, high: 3 } },
    ],
    hiddenFilters: ["abv"],
  },
  "uk-lager": {
    title: "UK Lager",
    description:
      "We're shining a spotlight on Lagers lovingly brewed right here in the UK — crisp, refreshing, and perfect for the warmer months ahead. From small-batch brews to cult classics, this is your cue to stock up on crispy bois and keep your taps and fridges summer-ready.",
    logoUrl:
      "https://sellar.imgix.net/sellar-image-assets/uk-lager-2025/text-logo.png",
    bannerSmallUrl:
      "https://sellar.imgix.net/sellar-image-assets/uk-lager-2025/slim-2.png",
    bannerMediumUrl:
      "https://sellar.imgix.net/sellar-image-assets/uk-lager-2025/medium.png",
    bannerLargeUrl:
      "https://sellar.imgix.net/sellar-image-assets/uk-lager-2025/large.png",
    spotlightBannerUrl:
      "https://sellar.imgix.net/sellar-image-assets/uk-lager-2025/new-aspect.png",
    search: "(lager)",
    query: [
      {
        type: "gbSupplier",
        modifier: "EQUALS",
        value: true,
      },
    ],
  },
  kombucha: {
    title: "Kombucha",
    description:
      "Discover kombucha on Sellar Market — raw, refreshing, and brewed by the UK's leading independent fermenters. From crisp classics to bold, fruity blends, this is living soda with flavour and function.",
    logoUrl:
      "https://sellar.imgix.net/sellar-image-assets/kombucha/kombucha-logo.png",
    bannerSmallUrl:
      "https://sellar.imgix.net/sellar-image-assets/kombucha/kombucha-medium.png",
    bannerMediumUrl:
      "https://sellar.imgix.net/sellar-image-assets/kombucha/kombucha-medium.png",
    bannerLargeUrl:
      "https://sellar.imgix.net/sellar-image-assets/kombucha/kombucha-large.png",
    spotlightBannerUrl:
      "https://sellar.imgix.net/sellar-image-assets/kombucha/kombucha-large.png",
    search: "(kombucha)",
  },
  "nitro-dark-beers": {
    title: "Nitro",
    description:
      "Elevate your offering with independently brewed Nitro dark beers. With their creamy texture, bold flavour profiles, and mesmerising cascade, they'll have customers coming back for more—and talking about you.",
    logoUrl:
      "https://sellar.imgix.net/sellar-image-assets/nitro/nitro-logo.png",
    bannerSmallUrl:
      "https://sellar.imgix.net/sellar-image-assets/nitro/nitro-medium.png",
    bannerMediumUrl:
      "https://sellar.imgix.net/sellar-image-assets/nitro/nitro-medium.png",
    bannerLargeUrl:
      "https://sellar.imgix.net/sellar-image-assets/nitro/nitro-large-new.png",
    spotlightBannerUrl:
      "https://sellar.imgix.net/sellar-image-assets/nitro/nitro-large-new.png",
    search: "(nitro porter|nitro stout)",
  },
  "drinks-suppliers-north-east": {
    title: "North East Suppliers",
    description:
      "From Newcastle's hop-forward trailblazers to Yorkshire's renowned breweries and Northumberland's hidden gems, the North East is bursting with brewing talent. Explore fresh, independent beer from across the region now pouring on Sellar Market.",
    logoUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-north-east-logo.png",
    bannerSmallUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-north-east-medium.png",
    bannerMediumUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-north-east-medium.png",
    bannerLargeUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-north-east-large.png",
    spotlightBannerUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-north-east-large.png",
  },
  "drinks-suppliers-north-west": {
    title: "North West Suppliers",
    description:
      "From Manchester's trailblazing beer scene to hidden gems across the North West, this is a region built on brewing heritage and innovation. Explore fresh, independent beer from the area's top producers now on Sellar Market.",
    logoUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-north-west-logo.png",
    bannerSmallUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-north-west-medium.png",
    bannerMediumUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-north-west-medium.png",
    bannerLargeUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-north-west-large.png",
    spotlightBannerUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-north-west-large.png",
  },
  "drinks-suppliers-midlands": {
    title: "Midlands Suppliers",
    description:
      "From Birmingham to Nottingham, Leicester to beyond, the Midlands is a hub of independent craft bursting with flavour and creativity. Explore standout beer, cider, spirits, and soda from the region's finest producers — all available now on Sellar Market.",
    logoUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-midlands-logo.png",
    bannerSmallUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-midlands-medium.png",
    bannerMediumUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-midlands-medium.png",
    bannerLargeUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-midlands-large.png",
    spotlightBannerUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-midlands-large.png",
  },
  "drinks-suppliers-east": {
    title: "East Suppliers",
    description:
      "From the coastline of Norfolk to the heart of Ipswich, the East of England is home to some of the UK's most exciting independent breweries. Dive into a curated selection of fresh, flavour-packed beer now pouring on Sellar Market.",
    logoUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-east-logo.png",
    bannerSmallUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-east-medium.png",
    bannerMediumUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-east-medium.png",
    bannerLargeUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-east-large.png",
    spotlightBannerUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-east-large.png",
  },
  "drinks-suppliers-south-west": {
    title: "South West Suppliers",
    description:
      "From the rugged coastlines of Cornwall and Devon to the buzzing craft scene in Bristol, the South West is a hotbed of independent drinks innovation. Explore fresh beer, cider, spirits, and more from the region's standout producers — all available now on Sellar Market.",
    logoUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-south-west-logo.png",
    bannerSmallUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-south-west-medium.png",
    bannerMediumUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-south-west-medium.png",
    bannerLargeUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-south-west-large.png",
    spotlightBannerUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-south-west-large.png",
  },
  "drinks-suppliers-south-east": {
    title: "South East Suppliers",
    description:
      "From the coastlines of Brighton and Southampton to the creative hubs of Essex and Oxford, the South East is home to a thriving craft drinks scene. Discover standout beer, cider, spirits, and more from the region's top independent producers — all on Sellar Market.",
    logoUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-south-east-logo.png",
    bannerSmallUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-south-east-medium-new.png",
    bannerMediumUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-south-east-medium-new.png",
    bannerLargeUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-south-east-large-new.png",
    spotlightBannerUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-south-east-large-new.png",
  },
  "drinks-suppliers-northern-ireland": {
    title: "Northern Irish Suppliers",
    description:
      "From the vibrant streets of Belfast to the rural edges of Northern Ireland, discover a new wave of independent craft. Explore bold beers, ciders, spirits, and softs from the region's top producers — all now available on Sellar Market.",
    logoUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-northern-ireland-logo.png",
    bannerSmallUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-northern-ireland-medium.png",
    bannerMediumUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-northern-ireland-medium.png",
    bannerLargeUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-northern-ireland-large-new.png",
    spotlightBannerUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-northern-ireland-large-new.png",
  },
  "drinks-suppliers-scotland": {
    title: "Scottish Suppliers",
    description:
      "From the bold brewers of Edinburgh and Glasgow to boundary-pushing distillers across the Highlands and beyond, Scotland's indie drinks scene is thriving. Discover standout beers and spirits from the country's top producers, all available now on Sellar Market.",
    logoUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-scotland-logo.png",
    bannerSmallUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-scotland-medium.png",
    bannerMediumUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-scotland-medium.png",
    bannerLargeUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-scotland-large-new.png",
    spotlightBannerUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-scotland-large-new.png",
  },
  "drinks-suppliers-wales": {
    title: "Welsh Suppliers",
    description:
      "From Cardiff to the coast, Wales is home to a vibrant craft scene rooted in tradition and creativity. Explore small-batch beer, cider, wine, and mead from the country's leading independent producers — all available now on Sellar Market.",
    logoUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-wales-logo.png",
    bannerSmallUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-wales-medium.png",
    bannerMediumUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-wales-medium.png",
    bannerLargeUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-wales-large-new.png",
    spotlightBannerUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-wales-large-new.png",
  },
  "drinks-suppliers-london": {
    title: "London Suppliers",
    description:
      "From the railway arches of Bermondsey to the creative corners of Hackney, London's indie drinks scene is packed with character. Explore bold beers, cider, rum, kombucha, soda, jerky and more from the capital's most exciting producers — all on Sellar Market.",
    logoUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-london-logo.png",
    bannerSmallUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-london-medium.png",
    bannerMediumUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-london-medium.png",
    bannerLargeUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-london-large-new.png",
    spotlightBannerUrl:
      "https://sellar.imgix.net/sellar-image-assets/regional-spotlight/drinks-suppliers-london-large-new.png",
  },
  "bristol-craft-beer-festival-2025": {
    title: "Bristol Craft Beer Festival",
    description:
      "Bristol's finest suppliers, all in one place. Discover the suppliers pouring the freshest drops at the BCBF trade day - only on Sellar Market.",
    logoUrl:
      "https://sellar.imgix.net/sellar-image-assets/bristol-craft-beer-festival-2025/bristol-craft-beer-festival-2025-logo.png",
    bannerSmallUrl:
      "https://sellar.imgix.net/sellar-image-assets/bristol-craft-beer-festival-2025/bristol-craft-beer-festival-2025-medium.png",
    bannerMediumUrl:
      "https://sellar.imgix.net/sellar-image-assets/bristol-craft-beer-festival-2025/bristol-craft-beer-festival-2025-medium.png",
    bannerLargeUrl:
      "https://sellar.imgix.net/sellar-image-assets/bristol-craft-beer-festival-2025/bristol-craft-beer-festival-2025-large.png",
    spotlightBannerUrl:
      "https://sellar.imgix.net/sellar-image-assets/bristol-craft-beer-festival-2025/bristol-craft-beer-festival-2025-banner-new1.png",
  },
  "sour-beer-2025": {
    title: "Sour Beer",
    description:
      "Embrace the tart takeover – discover the wild, the funky, and the refreshingly sharp from some of the UK's best breweries, all in one place on Sellar Market.",
    logoUrl:
      "https://sellar.imgix.net/sellar-image-assets/sour-beer-2025/sour-beer-logo.png",
    bannerSmallUrl:
      "https://sellar.imgix.net/sellar-image-assets/sour-beer-2025/sour-beer-medium.png",
    bannerMediumUrl:
      "https://sellar.imgix.net/sellar-image-assets/sour-beer-2025/sour-beer-medium.png",
    bannerLargeUrl:
      "https://sellar.imgix.net/sellar-image-assets/sour-beer-2025/sour-beer-large-new.png",
    spotlightBannerUrl:
      "https://sellar.imgix.net/sellar-image-assets/sour-beer-2025/sour-beer-medium.png",
    search: "(sour)",
  },
  "cider-perry-uk": {
    title: "Cider & Perry",
    description:
      "Discover standout UK indie cider and perry on Sellar Market — naturally fermented, full of character, and crafted with real fruit by independent makers. From juicy modern blends to wild, traditional styles, this is cider with a sense of place.",
    logoUrl:
      "https://sellar.imgix.net/sellar-image-assets/cider-perry-uk/cider-perry-uk-logo.png",
    bannerSmallUrl:
      "https://sellar.imgix.net/sellar-image-assets/cider-perry-uk/cider-perry-uk-medium.png",
    bannerMediumUrl:
      "https://sellar.imgix.net/sellar-image-assets/cider-perry-uk/cider-perry-uk-medium.png",
    bannerLargeUrl:
      "https://sellar.imgix.net/sellar-image-assets/cider-perry-uk/cider-perry-uk-large.png",
    spotlightBannerUrl:
      "https://sellar.imgix.net/sellar-image-assets/cider-perry-uk/cider-perry-uk-banner.png",
    search: "(cider|perry)",
  },
  "imported-beer": {
    title: "Imported Beer",
    description:
      "Discover a curated range of standout imported beers available on Sellar from producers around the world.",
    logoUrl:
      "https://sellar.imgix.net/sellar-image-assets/imported-beer/imported-beer-logo-final.png",
    bannerSmallUrl:
      "https://sellar.imgix.net/sellar-image-assets/imported-beer/imported-beer-medium-new.png",
    bannerMediumUrl:
      "https://sellar.imgix.net/sellar-image-assets/imported-beer/imported-beer-medium-new.png",
    bannerLargeUrl:
      "https://sellar.imgix.net/sellar-image-assets/imported-beer/imported-beer-large-new.png",
    spotlightBannerUrl:
      "https://sellar.imgix.net/sellar-image-assets/imported-beer/imported-beer-large-new.png",
  },
  "london-craft-beer-festival-2025": {
    title: "London Craft Beer Festival 2025",
    description:
      "Discover the craft drinks pouring at London Craft Beer Festival, all in one place. Offering the freshest drops pouring at the trade day - only on Sellar Market.",
    logoUrl:
      "https://sellar.imgix.net/sellar-image-assets/london-craft-beer-festival-2025/london-craft-beer-festival-2025-logo-new.png",
    bannerSmallUrl:
      "https://sellar.imgix.net/sellar-image-assets/london-craft-beer-festival-2025/london-craft-beer-festival-2025-medium.png",
    bannerMediumUrl:
      "https://sellar.imgix.net/sellar-image-assets/london-craft-beer-festival-2025/london-craft-beer-festival-2025-medium.png",
    bannerLargeUrl:
      "https://sellar.imgix.net/sellar-image-assets/london-craft-beer-festival-2025/london-craft-beer-festival-2025-large.png",
    spotlightBannerUrl:
      "https://sellar.imgix.net/sellar-image-assets/london-craft-beer-festival-2025/london-craft-beer-festival-2025-banner.png",
  },
  "taste-the-tropics-2025": {
    title: "Taste the Tropics",
    description:
      "A vibrant lineup of tropical beers and drinks bursting with juicy, sunshine-soaked flavour. From citrusy sours to coconut stouts, this spotlight brings the holiday vibes straight to you and your customers.",
    logoUrl:
      "https://sellar.imgix.net/sellar-image-assets/taste-the-tropics-2025/taste-the-tropics-2025-logo.png",
    bannerSmallUrl:
      "https://sellar.imgix.net/sellar-image-assets/taste-the-tropics-2025/taste-the-tropics-2025-medium.png",
    bannerMediumUrl:
      "https://sellar.imgix.net/sellar-image-assets/taste-the-tropics-2025/taste-the-tropics-2025-medium.png",
    bannerLargeUrl:
      "https://sellar.imgix.net/sellar-image-assets/taste-the-tropics-2025/taste-the-tropics-2025-large.png",
    spotlightBannerUrl:
      "https://sellar.imgix.net/sellar-image-assets/taste-the-tropics-2025/taste-the-tropics-2025-banner-new.png",
  },
  "hazy-daze-2025": {
    title: "Hazy Daze",
    description:
      "Hazy Daze puts the spotlight on the juiciest, hop-saturated Pales and IPAs available on Sellar right now. Think thick haze, big aroma and juicy flavours - these are the hazy beers your customers are looking for.",
    logoUrl:
      "https://sellar.imgix.net/sellar-image-assets/hazy-daze-2025/hazy-daze-2025-logo.png",
    bannerSmallUrl:
      "https://sellar.imgix.net/sellar-image-assets/hazy-daze-2025/hazy-daze-2025-small.png",
    bannerMediumUrl:
      "https://sellar.imgix.net/sellar-image-assets/hazy-daze-2025/hazy-daze-2025-medium.png ",
    bannerLargeUrl:
      "https://sellar.imgix.net/sellar-image-assets/hazy-daze-2025/hazy-daze-2025-large.png ",
    spotlightBannerUrl:
      "https://sellar.imgix.net/sellar-image-assets/hazy-daze-2025/hazy-daze-2025-spotlight-banner.png",
  },
  "oktoberfest-2025": {
    title: "Oktoberfest 2025",
    description:
      "Browse all our suppliers' Oktoberfest beers in one place. Pick and choose limited edition, German-style beers from the UK's best craft breweries.",
    logoUrl:
      "https://sellar.imgix.net/sellar-image-assets/oktoberfest-2025/oktoberfest-2025-logo.png",
    bannerSmallUrl:
      "https://sellar.imgix.net/sellar-image-assets/oktoberfest-2025/oktoberfest-2025-small.png",
    bannerMediumUrl:
      "https://sellar.imgix.net/sellar-image-assets/oktoberfest-2025/oktoberfest-2025-medium.png",
    bannerLargeUrl:
      "https://sellar.imgix.net/sellar-image-assets/oktoberfest-2025/oktoberfest-2025-large.png ",
    spotlightBannerUrl:
      "https://sellar.imgix.net/sellar-image-assets/oktoberfest-2025/oktoberfest-2025-spotlight-banner.png",
  },
  "cask-beer": {
    title: "Cask Beer",
    description:
      "Explore the best of cask beer on Sellar Market — expertly brewed, full of character, and rooted in rich UK brewing heritage. From traditional bitters to modern pale ales, this is where classic craft meets the hand-pulled pint.",
    logoUrl:
      "https://sellar.imgix.net/sellar-image-assets/cask-beer/cask-beer-logo.png",
    bannerSmallUrl:
      "https://sellar.imgix.net/sellar-image-assets/cask-beer/cask-beer-small.png",
    bannerMediumUrl:
      "https://sellar.imgix.net/sellar-image-assets/cask-beer/cask-beer-medium.png",
    bannerLargeUrl:
      "https://sellar.imgix.net/sellar-image-assets/cask-beer/cask-beer-large.png",
    spotlightBannerUrl:
      "https://sellar.imgix.net/sellar-image-assets/cask-beer/cask-beer-spotlight-banner.png",
  },
} as const;

export const useGetSpotlightPageData = (
  pageId: string,
): {
  data: SpotlightPagesType & {
    pageId: string;
    entityIds: SpotlightPageGetResponseType["entityIds"];
    type: SpotlightPageGetResponseType["type"] | undefined;
  };
  loading: boolean;
} => {
  const spotlightPageQuery = useSpotlightPage(pageId);
  const spotlightPageData = spotlightPageQuery.data;
  const spotlightPageFallbackData = fallbackSpotlightPages[pageId];

  // TODO: Remove fallback description after 10/01/2026
  const description =
    spotlightPageData?.description ||
    spotlightPageFallbackData?.description ||
    "";

  // TODO: Remove fallback title after 10/01/2026
  const title =
    spotlightPageData?.title || spotlightPageFallbackData?.title || "";

  // TODO: Remove fallback logoUrl after 10/01/2026
  const logoUrl =
    spotlightPageData?.SpotlightPageImages.find(
      (image) => image.type === "logo",
    )?.url ?? spotlightPageFallbackData?.logoUrl;

  // TODO: Remove fallback bannerSmallUrl after 10/01/2026
  const bannerSmallUrl =
    spotlightPageData?.SpotlightPageImages.find(
      (image) => image.type === "bannerSmall",
    )?.url ?? spotlightPageFallbackData?.bannerSmallUrl;

  // TODO: Remove fallback bannerMediumUrl after 10/01/2026
  const bannerMediumUrl =
    spotlightPageData?.SpotlightPageImages.find(
      (image) => image.type === "bannerMedium",
    )?.url ?? spotlightPageFallbackData?.bannerMediumUrl;

  // TODO: Remove fallback bannerLargeUrl after 10/01/2026
  const bannerLargeUrl =
    spotlightPageData?.SpotlightPageImages.find(
      (image) => image.type === "bannerLarge",
    )?.url ?? spotlightPageFallbackData?.bannerLargeUrl;

  // TODO: Remove fallback spotlightBannerUrl after 10/01/2026
  const spotlightBannerUrl =
    spotlightPageData?.SpotlightPageImages.find(
      (image) => image.type === "spotlightBanner",
    )?.url ?? spotlightPageFallbackData?.spotlightBannerUrl;

  return {
    data: {
      pageId,
      ...spotlightPageFallbackData,
      entityIds: spotlightPageData?.entityIds ?? [],
      type: spotlightPageData?.type,
      title,
      description,
      logoUrl,
      bannerSmallUrl,
      bannerMediumUrl,
      bannerLargeUrl,
      spotlightBannerUrl,
    },
    loading: spotlightPageQuery.isPending,
  };
};
